<template>
  <div
    v-if="isVisible"
    class="fulloverlay fixed inset-0 flex items-center justify-center overflow-hidden"
    style="background: rgba(0, 0, 0, 0.5); backdrop-filter: blur(2px)"
  >
    <div class="loader">
      <div class="bar" />
      <div class="bar" />
      <div class="bar" />
      <div class="bar" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useFullSpinnerStore } from '~/store/fullSpinner';

const store = useFullSpinnerStore();

const isVisible = ref(false);

const show = () => {
  isVisible.value = true;
};

const hide = () => {
  isVisible.value = false;
};

watch(
  () => store.fullSpinner,
  (value) => {
    if (value) {
      show();
    } else {
      hide();
    }
  }
);
</script>

<style scoped>
@reference "@/assets/css/tailwind.css";
.fulloverlay {
  z-index: 99999;
  overflow-y: hidden !important;
}

.loader {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.bar {
  width: 15px;
  height: 100%;
  background-color: #750800;
  animation: jump 1s ease-in-out infinite;
}

.bar:nth-child(1) {
  animation-delay: 0.1s;
}

.bar:nth-child(2) {
  animation-delay: 0.2s;
}

.bar:nth-child(3) {
  animation-delay: 0.3s;
}

.bar:nth-child(4) {
  animation-delay: 0.4s;
}

@keyframes jump {
  0%,
  100% {
    transform: translateY(0);
    background-color: #750800;
  }
  50% {
    transform: translateY(-50px);
    background-color: #ffffff;
  }
}
</style>
